class NostoStateLayer {
  constructor() {
    this.state = {
      activeFacets: [],
      activeSort: { field: 'score', order: 'desc' },
      facets: [],
      lastSelectedDetail: null,
      pagination: { currentPage: 1 },
      products: [],
      sort: [
        { field: 'score', order: 'desc', label: 'Relevance', selected: true },
        { field: 'price', order: 'asc', label: 'Price: Low to High', selected: false },
        { field: 'price', order: 'desc', label: 'Price: High to Low', selected: false },
        { field: 'name', order: 'asc', label: 'Name: A to Z', selected: false },
        { field: 'name', order: 'desc', label: 'Name: Z to A', selected: false },
        { field: 'datePublished', order: 'desc', label: 'Newest', selected: false },
        { field: 'datePublished', order: 'asc', label: 'Oldest', selected: false }
      ],
    };

    this.subscribeToEvents();
    this.initializeActiveFacetsFromSearchParams();
  }

  subscribeToEvents() {
    const eventBus = window.theme.category.eventBus;

    // Subscribe to product updates
    eventBus.subscribe('category:api:products:fetched', (response) => {
      const hits = response.products.hits;

      const promos = theme.category.apiLayer.promos

      // Calculate total column span from promos
      const totalColumnSpan = promos ? promos.reduce((total, promo) => {
        return total + (promo.column_span || 1);
      }, 0) : 0;

      const pagination = {
        total: response.products.total,
        size: response.products.size,
        from: response.products.from,
        totalPages: Math.ceil((response.products.total + totalColumnSpan) / response.products.size),
      };

      this.products = hits;
      this.pagination = { ...this.state.pagination, ...pagination };
    });

    // Subscribe to facet updates
    eventBus.subscribe('category:api:facets:fetched', (facets) => {
      this.facets = facets;
    });

    // Subscribe to UI facet changes
    eventBus.subscribe('category:ui:facets:changed', ({ field, value }) => {
      if (field === 'sort') {
        const sortValue = value[0].split('~');
        this.activeSort = {
          field: sortValue[0],
          order: sortValue[1]
        };

        this.state.lastSelectedDetail = 'sort';
        this.updateSearchParams();
        return;
      } else {
        this.activeFacets = [
          ...this.state.activeFacets.filter(facet => facet.field !== field),
          { field, value }
        ];
        this.state.lastSelectedDetail = field;
        this.updateSearchParams();
      }
    });

    // Subscribe to facet removal
    eventBus.subscribe('category:ui:facet:removed', ({ field, value }) => {
      const fieldToRemove = this.state.activeFacets.find(facet => facet.field === field);
      if (fieldToRemove) {
        const valueIndex = fieldToRemove.value.indexOf(value);
        fieldToRemove.value.splice(valueIndex, 1);
      }
      // Build and append search parameters
      this.updateSearchParams();
    });

    // Subscribe to sort changes
    eventBus.subscribe('category:ui:sort:changed', (sort) => {
      this.activeSort = sort;
      this.updateSearchParams();
    });

    eventBus.subscribe('category:state:activeSort:updated', (activeSort) => {
      this.state.sort.forEach(sort => {
        if (sort.field === activeSort.field && sort.order === activeSort.order) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
    });


    // Subscribe to pagination changes
    eventBus.subscribe('category:ui:pagination:changed', (cursor) => {
      this.paginationCursor = cursor.current;
      this.updateSearchParams(cursor.direction);
    });


    // Subscribe to clear all facets
    eventBus.subscribe('category:ui:facet:clearAll', () => {
      this.activeFacets = [];
      this.activeSort = { field: 'score', order: 'desc' };
      this.state.lastSelectedDetail = null;
      this.updateSearchParams();
    });
  }

  initializeActiveFacetsFromSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const activeFacets = [];

    searchParams.forEach((value, key) => {
      const values = value.includes(',') ? value.split(',') : [value];

      switch (key) {
        case 'sort':
          const [field, order] = values[0].split('~');
          this.activeSort = { field, order };
          break;
        case 'page':
          const currentPage = parseInt(value, 10);
          if (!isNaN(currentPage) && currentPage > 0) {
            this.state.pagination.currentPage = currentPage;
          }
          break;
        default:
          if (key !== 'page') {
            activeFacets.push({ field: key, value: values });
          }
      }
    });

    this.activeFacets = activeFacets.filter(facet => facet.field.includes('customFields'));
  }

  calculateFrom(currentPage, pageSize) {
    return (currentPage - 1) * pageSize;
  }

  updateSearchParams(paginationDirection) {
    clearTimeout(this.updateSearchParamsTimeout);
    this.updateSearchParamsTimeout = setTimeout(() => {
      const searchParams = new URLSearchParams();

      this.state.activeFacets.forEach(facet => {
        if (facet.value.length > 0) {
          searchParams.set(facet.field, facet.value.join(','));
          searchParams.delete('page');

          this.state.pagination.from = 0;
        }
      });

      if (this.state.activeSort) {
        searchParams.set('sort', `${this.state.activeSort.field}~${this.state.activeSort.order}`);
      }

      if (this.state.pagination.currentPage <= this.state.pagination.totalPages) {
        if(paginationDirection === 'next') {
          this.state.pagination.currentPage += 1;
        } else if (paginationDirection === 'previous') {
          this.state.pagination.currentPage -= 1;
        } else {
          this.state.pagination.currentPage = 1;
        }

        if (paginationDirection) {
          searchParams.set('page', this.state.pagination.currentPage);
        }
      }

      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, '', newUrl);

      console.log(`[State Update] Publishing fetch for targetPage: ${this.state.pagination.currentPage}`);
      // Explicitly pass the calculated targetPage to the API fetch event
      // Also pass the direction to handle offset logic correctly
      window.theme.category.eventBus.publish('category:api:fetch:products', {
        targetPage: this.state.pagination.currentPage,
        direction: paginationDirection // Pass the direction
      });

    }, 300); // Debounce time

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  set products(products) {
    this.state.products = products;
    window.theme.category.eventBus.publish('category:state:products:updated', products);
  }

  set facets(facets) {
    this.state.facets = facets;
    window.theme.category.eventBus.publish('category:state:facets:updated', facets);
  }

  set activeFacets(activeFacets) {
    this.state.activeFacets = activeFacets;
  }

  set activeSort(activeSort) {
    this.state.activeSort = activeSort;
    window.theme.category.eventBus.publish('category:state:activeSort:updated', activeSort);
  }

  set pagination(pagination) {
    this.state.pagination = pagination;
  }

  set paginationCursor(cursor) {
    this.state.pagination.from = Number(cursor);
  }
}

window.theme.category.stateLayer = new NostoStateLayer();
